var _defs, _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPresent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "present_svg__Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.61 89.61"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".present_svg__cls-2{fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.81,
    cy: 44.81,
    r: 44.81,
    fill: "#fedf00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "present_svg__cls-2",
    d: "M15.34 26.25h61.29v11.3H15.34zM17.29 38.23h54.74v34.48H17.29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#239ed4",
    d: "M39.38 26.25h11.05v46.46H39.38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.32 23.81h-7.96a9.748 9.748 0 001.96-5.87c0-5.39-4.39-9.78-9.78-9.78-3.25 0-5.64 1.16-7.54 3.66-1.58 2.09-2.74 5.01-4.2 8.7-1.45-3.69-2.61-6.61-4.2-8.7-1.89-2.5-4.29-3.66-7.54-3.66-5.39 0-9.78 4.39-9.78 9.78 0 2.2.73 4.23 1.96 5.87h-7.96c-3.24 0-5.87 2.63-5.87 5.87v3.91c0 2.55 1.64 4.72 3.91 5.53v29.93c0 3.24 2.63 5.87 5.87 5.87h47.2c3.24 0 5.87-2.63 5.87-5.87V39.12a5.871 5.871 0 003.91-5.53v-3.91c0-3.24-2.63-5.87-5.87-5.87zM48.4 22.08c3-7.6 4.14-10.01 8.14-10.01 3.24 0 5.87 2.63 5.87 5.87s-2.63 5.87-5.87 5.87h-8.83c.24-.6.47-1.18.68-1.73zM33.08 12.07c4.01 0 5.15 2.4 8.14 10.01.22.55.44 1.13.68 1.73h-8.83c-3.24 0-5.87-2.63-5.87-5.87s2.63-5.87 5.87-5.87zM36.99 71H21.21c-1.08 0-1.96-.88-1.96-1.96v-29.6h17.73v31.55zm0-35.46H17.3c-1.08 0-1.96-.88-1.96-1.96v-3.91c0-1.08.88-1.96 1.96-1.96h19.69v7.82zM48.72 71H40.9V27.72h7.82v43.29zm21.64-1.96c0 1.08-.88 1.96-1.96 1.96H52.62V39.45h17.73v29.6zm3.91-35.46c0 1.08-.88 1.96-1.96 1.96H52.62v-7.82h19.69c1.08 0 1.96.88 1.96 1.96v3.91z"
  })));
}

export default SvgPresent;